import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { HistoryService } from '../../services/history.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-support-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class SupportHistoryComponent implements OnInit {
  histories$: Observable<any>;
  isLoaded: boolean = false;
  vtubers: any[];

  constructor(
    public auth: AuthService,
    private hs: HistoryService
  ) {}

  ngOnInit() {
    // this.loadHistories()  
    const source = this.hs.getHistories()
    this.histories$ = this.hs.getData(source)
  }

  async loadHistories() {
  }
}
